import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import MuiTableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import PropTypes from 'prop-types'
import React from 'react'

import Box from './box'
import Pagination from './pagination'
import Stack from './stack'
import Text from './text'

const HeadCell = ({ children, variant }) => (
  <MuiTableCell>
    <Text variant={variant}>{children}</Text>
  </MuiTableCell>
)

HeadCell.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.string,
}

HeadCell.defaultProps = {
  variant: 'avenir14Bold',
}

const TableCell = ({ children, variant }) => (
  <MuiTableCell>
    <Text variant={variant}>{children}</Text>
  </MuiTableCell>
)

TableCell.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.string,
}

TableCell.defaultProps = {
  variant: 'avenir14',
}

const Row = ({ children }) => (
  <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>{children}</TableRow>
)

Row.propTypes = {
  children: PropTypes.node.isRequired,
}

const TablePagination = ({ page, perPage, total, onPaginationChange }) => {
  const rangeStart = (page - 1) * perPage + 1
  const rangeEnd = Math.min(total, page * perPage)
  const paginationCount = Math.ceil(total / perPage)

  if (!total) {
    return null
  }

  return (
    <Stack padding={2} direction="row-reverse" justifyContent="space-between" alignItems="center">
      <Box>
        <Text variant="avenir12">
          Showing {rangeStart}-{rangeEnd} of {total}
        </Text>
      </Box>
      {paginationCount > 1 && (
        <Pagination count={paginationCount} page={page} onChange={onPaginationChange} />
      )}
    </Stack>
  )
}

TablePagination.propTypes = {
  page: PropTypes.number.isRequired,
  perPage: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  onPaginationChange: PropTypes.func.isRequired,
}

Table.Body = TableBody
Table.Cell = TableCell
Table.Head = TableHead
Table.HeadCell = HeadCell
Table.Row = Row
Table.Pagination = TablePagination

export default Table
